import { render, staticRenderFns } from "./size.vue?vue&type=template&id=244f5004&scoped=true"
import script from "./size.vue?vue&type=script&lang=ts"
export * from "./size.vue?vue&type=script&lang=ts"
import style0 from "./size.vue?vue&type=style&index=0&id=244f5004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f5004",
  null
  
)

export default component.exports